angular.module("vgresiduos").controller("VertownNotificationListCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `master/comunicados-vertown`);
		};
	}
]);
